const getParamName = (flow) => `is${flow}ModalOpen`;
export const SET_MODAL_STATE = 'SET_MODAL_STATE';
export const MODAL_PARAM_ONBOARDING = getParamName('OnboardingModal');
export const MODAL_PARAM_PHONE_UPDATE = getParamName('PhoneUpdate');

export const MODAL_PARAM_EMAIL_VERIFICATION = getParamName('EmailVerification');
export const MODAL_PARAM_PHONE_VERIFICATION = getParamName('PhoneVerification');

export const ALLOWED_MODALS_TO_OPEN_BY_QUERY = [];

export const MODAL_INVITE_MEMBER = getParamName('InviteMember');
export const MODAL_UNSAVED_BUYBOX_CHANGES = getParamName(
  'UnsavedBuyBoxChanges',
);

export const MODAL_ACCEPT_TERMS_AND_CONDITIONS = getParamName(
  'AcceptTermsAndConditions',
);

export const MODAL_WHITELABEL_ACCEPT_TERMS_AND_CONDITIONS = getParamName(
  'WhitelabelAcceptTermsAndConditions',
);

export const PRE_DEALS_MODAL_TRAINING = getParamName('PreDealsTraining');

export const MODAL_CONTACT_SPECIALIST = getParamName('ContactSpecialist');
export const MODAL_PARAM_WHITELABEL_BUYERS_TRAINING = getParamName(
  'WhiteLabelTraining',
);
export const MODAL_EDIT_FIELD = getParamName('EditField');

export const MODAL_CREATE_ENTITY = getParamName('CreateEntity');
export const MODAL_ADD_ASSET = getParamName('AddAsset');
